import { ChartBlock, JobsTooltip, Period } from '@/ui-kit'
import { useState } from 'react'
import { Worker } from '../api/models'
import { useFetchWorkerJobs } from '../api/useFetchWorkerJobs'
import { useFetchWorkerJobsPoints } from '../api/useFetchWorkerJobsPoints'
import { useFetchWorkerUptime } from '../api/useFetchWorkerUptime'
import { useFetchWorkerUptimePoints } from '../api/useFetchWorkerUptimePoints'
import { getDeviceDescription } from '../utils/getDeviceDescription'

export function DeviceStats({ worker }: { worker: Worker }): React.JSX.Element {
  const [pointsPeriod, setPointsPeriod] = useState<Period>('day')
  const [jobsPeriod, setJobsPeriod] = useState<Period>('day')
  const [uptimePeriod, setUptimePeriod] = useState<Period>('day')
  const { data: points } = useFetchWorkerJobsPoints(worker.id, pointsPeriod)
  const { data: uptimePoints } = useFetchWorkerUptimePoints(worker.id, pointsPeriod)

  const { data: nonRestrictedJobs } = useFetchWorkerJobs(worker.id, jobsPeriod)

  const { data: uptime } = useFetchWorkerUptime(worker.id, uptimePeriod)
  const targetDate = { title: 'Device was activated', date: worker.createdAt }
  const noDataText = (
    <>
      No data available for{' '}
      <span className="max-mobile:block">&quot;{getDeviceDescription(worker?.metadata?.userAgent, true)}&quot; yet</span>
    </>
  )

  return (
    <div className="mt-4 flex flex-1 flex-col gap-4 max-tablet:mx-0">
      <ChartBlock
        title={{ plural: 'DataHive Points', singular: 'DataHive Point' }}
        data={points}
        data3={uptimePoints}
        period={pointsPeriod}
        onPeriodChange={setPointsPeriod}
        noDataText={noDataText}
        targetDate={targetDate}
        isStackedBars
      />
      <ChartBlock
        title={{ plural: 'Jobs', singular: 'Job' }}
        data={nonRestrictedJobs}
        period={jobsPeriod}
        onPeriodChange={setJobsPeriod}
        noDataText={noDataText}
        targetDate={targetDate}
        tooltipNode={JobsTooltip as any}
      />
      <ChartBlock
        title={{ plural: 'Uptime', singular: 'Uptime' }}
        data={uptime}
        period={uptimePeriod}
        onPeriodChange={setUptimePeriod}
        noDataText={noDataText}
        targetDate={targetDate}
        isPercents
      />
    </div>
  )
}
